export default "__VITE_ASSET__92855b26__"